// 运用场景：时间格式化

var timeFormat = {};
// 获取时间年月日
timeFormat.toDate = function (time, format = '-') {
    let result = '';
    if (time) {
        // let str = time.toString().substring(time.length - 2);
        // if (str == ".0") {
        //   time = time.toString().substring(0, time.length - 2);
        // }
        time = new Date(Date.parse(time.toString().replace(/[-\.]/g, "/")));
        // time = new Date(time);
        let year = time.getFullYear();
        let month = time.getMonth() + 1;//js从0开始取
        let date = time.getDate();

        if (month < 10) {
            month = "0" + month;
        }
        if (date < 10) {
            date = "0" + date;
        }

        result = year + format + month + format + date; //2009-06-12
    }
    return result;
};
timeFormat.toDate2 = function (time) {
    let result = '';
    if (time) {
        // let str = time.toString().substring(time.length - 2);
        // if (str == ".0") {
        //   time = time.toString().substring(0, time.length - 2);
        // }
        time = new Date(Date.parse(time.toString().replace(/[-\.]/g, "/")));
        // time = new Date(time);
        let year = time.getFullYear();
        let month = time.getMonth() + 1;//js从0开始取
        let date = time.getDate();

        if (month < 10) {
            month = "0" + month;
        }
        if (date < 10) {
            date = "0" + date;
        }

        result = year + '年' + month + '月' + date + '日'; //2009-06-12
    }
    return result;
};

// 获取时间年月日时分秒
timeFormat.toDateTime = function (time, format = '-') {
    let result = '';
    if (time) {
        time = new Date(Date.parse(time.toString().replace(/[-\.]/g, "/")));
        // time = new Date(time);
        let year = time.getFullYear();
        let month = time.getMonth() + 1;//js从0开始取
        let date = time.getDate();
        let hour = time.getHours();
        let minutes = time.getMinutes();
        let second = time.getSeconds();

        if (month < 10) {
            month = "0" + month;
        }
        if (date < 10) {
            date = "0" + date;
        }
        if (hour < 10) {
            hour = "0" + hour;
        }
        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        if (second < 10) {
            second = "0" + second;
        }

        result = year + format + month + format + date + " " + hour + ":" + minutes + ":" + second; //2009-06-12 17:18:05
    }

    return result;
};
timeFormat.toDateTime2 = function (time) {
    let result = '';
    if (time) {
        time = new Date(Date.parse(time.toString().replace(/[-\.]/g, "/")));
        // time = new Date(time);
        let year = time.getFullYear();
        let month = time.getMonth() + 1;//js从0开始取
        let date = time.getDate();
        let hour = time.getHours();
        let minutes = time.getMinutes();
        let second = time.getSeconds();

        month = month < 10 ? "0" + month : month.toString();
        date = date < 10 ? "0" + date : date.toString();
        hour < 10 ? hour = "0" + hour : hour.toString();
        minutes < 10 ? minutes = "0" + minutes : minutes.toString();
        second < 10 ? second = "0" + second : second.toString();

        result = year + month + date + hour + minutes + second; //20090612171805
    }

    return result;
};

// 根据开始时间和结束时间获取该时间段内的每天
timeFormat.getDayAll = function (begin, end) {
    let dateAllArr = [];
    let ab = this.toDate(begin, '/').split("/");
    let ae = this.toDate(end, '/').split("/");
    let db = new Date();
    db.setUTCFullYear(ab[0], ab[1] - 1, ab[2]);
    let de = new Date();
    de.setUTCFullYear(ae[0], ae[1] - 1, ae[2]);
    let unixDb = db.getTime();
    let unixDe = de.getTime();
    for (let k = unixDb; k <= unixDe;) {
        dateAllArr.push(this.toDate(new Date(parseInt(k)), '/'));
        k = k + 24 * 60 * 60 * 1000;
    }
    return dateAllArr;
};

// 根据开始时间和结束时间获取该时间段内的每月
timeFormat.getMonthAll = function (begin, end) {
    var dateArry = new Array();
    var s1 = this.toDate(begin, '/').split("/");
    var s2 = this.toDate(end, '/').split("/");
    var mCount = 0;
    if (parseInt(s1[0]) < parseInt(s2[0])) {
        mCount = (parseInt(s2[0]) - parseInt(s1[0])) * 12 + parseInt(s2[1]) - parseInt(s1[1]) + 1;
    } else {
        mCount = parseInt(s2[1]) - parseInt(s1[1]) + 1;
    }
    if (mCount > 0) {
        var startM = parseInt(s1[1]);
        var startY = parseInt(s1[0]);
        for (var i = 0; i < mCount; i++) {
            if (startM < 12) {
                dateArry[i] = startY + "-" + (startM > 9 ? startM : "0" + startM);
                startM += 1;
            } else {
                dateArry[i] = startY + "-" + (startM > 9 ? startM : "0" + startM);
                startM = 1;
                startY += 1;
            }
        }
    }
    return dateArry;
};

// 根据开始时间和结束时间获取该时间段内的每年
timeFormat.getYearAll = function (begin, end) {
    var dateArry = new Array();
    var s1 = this.toDate(begin, '/').split("/");
    var s2 = this.toDate(end, '/').split("/");
    var mYearCount = parseInt(s2[0]) - parseInt(s1[0]) + 1;
    var startY = parseInt(s1[0]);
    for (var i = 0; i < mYearCount; i++) {
        dateArry[i] = startY;
        startY += 1;
    }
    return dateArry;
};

// 比较一个数组里面时间的最大最小值，返回数据：最大值：endTime,最小值：startTime;参数要求：arr,sField:开始时间字段，eField:结束时间字段
timeFormat.compareTime = function (arr, sField, eField) {
    let obj = {
        startTime: '',
        endTime: ''
    };
    if (arr.length) {
        obj = {
            startTime: this.toDate(arr[0][sField], '/'),
            endTime: this.toDate(arr[0][eField], '/')
        };
    }
    for (let data of arr) {
        let startTime = this.toDate(data[sField], '/');
        let endTime = this.toDate(data[eField], '/');
        if (startTime < obj.startTime) {
            obj.startTime = startTime;
        }
        if (endTime > obj.endTime) {
            obj.endTime = endTime;
        }
    }
    console.log('obj-----------', obj);
    return obj;
};

// 获取当前时间并计算N天前的日期
timeFormat.getDateBeforeNow = function (AddDayCount, format = "/") {
    let nowDate = new Date();
    nowDate.setDate(nowDate.getDate() - AddDayCount)    // 获取AddDayCount天前的日期
    let y = nowDate.getFullYear();
    let m = (nowDate.getMonth() + 1) < 10 ? "0" + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)  // 获取当前月份的日期，不足10补0
    let d = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate()       // 获取当前几号，不足10补0
    return y + format + m + format + d
};

//时间戳转化为刚刚/N分钟前/今天几点几分/昨天几点几分等
timeFormat.timestampFormat = function (timestamp) {
    timestamp = new Date(Date.parse(timestamp.toString().replace(/[-\.]/g, "/")));

    function zeroize(num) {
        return (String(num).length == 1 ? '0' : '') + num;
    }

    let curTimestamp = new Date().getTime(); //当前时间戳
    let timestampDiff = curTimestamp - timestamp; // 参数时间戳与当前时间戳相差秒数
    let curDate = new Date(); // 当前时间日期对象
    let tmDate = new Date(timestamp);  // 参数时间戳转换成的日期对象
    let Y = tmDate.getFullYear(), m = tmDate.getMonth() + 1, d = tmDate.getDate();
    let H = tmDate.getHours(), i = tmDate.getMinutes(), s = tmDate.getSeconds();


    if (timestampDiff < 60) { // 一分钟以内
        return "刚刚";
    } else if (timestampDiff < 3600) { // 一小时前之内
        return Math.floor(timestampDiff / 60) + "分钟前";
    } else if (curDate.getFullYear() == Y && curDate.getMonth() + 1 == m && curDate.getDate() == d) {
        return '今天' + zeroize(H) + ':' + zeroize(i);
    } else {
        let newDate = new Date((curTimestamp - 86400000)); // 参数中的时间戳加一天转换成的日期对象
        if (newDate.getFullYear() == Y && newDate.getMonth() + 1 == m && newDate.getDate() == d) {
            return '昨天' + zeroize(H) + ':' + zeroize(i);
        } else if (curDate.getFullYear() == Y) {
            return zeroize(m) + '月' + zeroize(d) + '日 ' + zeroize(H) + ':' + zeroize(i);
        } else {
            return Y + '年' + zeroize(m) + '月' + zeroize(d) + '日 ' + zeroize(H) + ':' + zeroize(i);
        }
    }
};

//获取时间段内每一天的日期
// (2018-10-19,7,'-') => [ '2018-10-13', '2018-10-14', '2018-10-15', '2018-10-16', '2018-10-17','2018-10-18','2018-10-19' ]
timeFormat.getEveryDate = (date, num, format = '/') => {
    let base = new Date(date).getTime(); //时间戳
    let oneDay = 24 * 3600 * 1000;
    let resultDate = [];
    // let data = [Math.random() * 300];
    let time = new Date(base);
    resultDate.push([time.getFullYear(), (time.getMonth() + 1) >= 10 ? (time.getMonth() + 1) : '0' + (time.getMonth() + 1), time.getDate() >= 10 ? time.getDate() : '0' + time.getDate()].join(format)); //传入的日期
    for (let i = 1; i < num; i++) {
        //每一天的日期
        let now = new Date(base -= oneDay); //GTM时间
        resultDate.push([now.getFullYear(), (now.getMonth() + 1) >= 10 ? (now.getMonth() + 1) : '0' + (now.getMonth() + 1), now.getDate() >= 10 ? now.getDate() : '0' + now.getDate()].join(format));
        // data.push(Math.round((Math.random() - 0.5) * 20 + data[i - 1]));
    }
    let newdate = resultDate.reverse();
    return newdate
};

//倒计时 endTime截止时间 "2018-11-20 23:00:00"
timeFormat.countTime = (endTime) => {
    //获取当前时间
    let date = new Date();
    let now = date.getTime();
    //设置截止时间 时间戳
    let arr = endTime.split(/[- :]/);
    let end = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
    end = Date.parse(end);
    /*let endDate = new Date(endTime);
    let end = endDate.getTime();*/
    //时间差
    let leftTime = end - now;
    //定义变量 d,h,m,s保存倒计时的时间
    let d, h, m, s;
    if (leftTime >= 0) {
        d = Math.floor(leftTime / 1000 / 60 / 60 / 24); //日
        h = Math.floor(leftTime / 1000 / 60 / 60 % 24);  //时
        m = Math.floor(leftTime / 1000 / 60 % 60);  //分
        s = Math.floor(leftTime / 1000 % 60);   //秒
    }
    // d = d > 9 ? d : '0' + d;
    h = h > 9 ? h : '0' + h;
    m = m > 9 ? m : '0' + m;
    s = s > 9 ? s : '0' + s;

    //递归每秒调用countTime方法，显示动态时间效果
    // setTimeout(timeFormat.countTime(endTime), 1000);

    return d + '天' + h + ':' + m + ':' + s
};

// 毫秒转成天数
timeFormat.getTimeHour = function (mss) {
    let result = {
        days: '',
        hours: '',
        minutes: '',
        seconds: ''
    };
    let days = parseInt(mss / (1000 * 60 * 60 * 24));
    let hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = (mss % (1000 * 60)) / 1000;
    result = {
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
    return result;
};

/**
 * 日期快捷选项
 * */
//昨日
timeFormat.getYesterday = function (params = []) {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
    end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
    params.push(timeFormat.toDate(start))
    params.push(timeFormat.toDate(end))
    return params
};
//今日
timeFormat.getToday = function (params = []) {
    const end = new Date();
    const start = new Date();
    params.push(timeFormat.toDate(start))
    params.push(timeFormat.toDate(end))
    return params
};
//上周
timeFormat.getLastWeek = function (params = []) {
    let Nowdate = new Date();
    //上周第一天 getDay() 方法可返回表示星期的某一天的数字 0（周日到6（周六） 86400000ms(1天) (3600 * 1000 * 24 * 7)7天
    //Nowdate - (Nowdate.getDay() - 1) * 86400000 => 本周第一天 减去 7天 = 上周第一天
    let LastWeekFirstDay = new Date(Nowdate - (Nowdate.getDay() - 1) * 86400000 - 3600 * 1000 * 24 * 7);
    let M = Number(LastWeekFirstDay.getMonth()) + 1;
    const start = new Date(Nowdate.getFullYear() + "/" + M + "/" + LastWeekFirstDay.getDate());
    const end = new Date(start.getTime() + 3600 * 1000 * 24 * 6)
    params.push(timeFormat.toDate(start))
    params.push(timeFormat.toDate(end))
    return params
};
//本周
timeFormat.getThisWeek = function (params = []) {
    let Nowdate = new Date();
    let WeekFirstDay = new Date(Nowdate - (Nowdate.getDay() - 1) * 86400000);
    let M = Number(WeekFirstDay.getMonth()) + 1;
    const end = new Date();
    const start = new Date(Nowdate.getFullYear() + "/" + M + "/" + WeekFirstDay.getDate());
    params.push(timeFormat.toDate(start))
    params.push(timeFormat.toDate(end))
    return params
};
//上月
timeFormat.getLastMonth = function (params = []) {
    let Nowdate = new Date();
    let LastMonthFirstDay = Nowdate.getFullYear() + "/" + Nowdate.getMonth() + "/01";
    //上个月最后一天 getDate()返回月份某一天  1 ~ 31 之间的一个整数
    //new Date(Nowdate.getFullYear(),Nowdate.getMonth(), 0).getDate() => 获取此年此月的最后一天日期
    let LastMonthLastDay = Nowdate.getFullYear() + "/" + Nowdate.getMonth() + "/" + new Date(Nowdate.getFullYear(), Nowdate.getMonth(), 0).getDate();
    const start = new Date(LastMonthFirstDay);
    const end = new Date(LastMonthLastDay);
    params.push(timeFormat.toDate(start))
    params.push(timeFormat.toDate(end))
    return params
};
//本月
timeFormat.getThisMonth = function (params = []) {
    let Nowdate = new Date();
    let thisMonthFirstDay = Nowdate.getFullYear() + "/" + (Nowdate.getMonth() + 1) + "/01";
    const start = new Date(thisMonthFirstDay);
    const end = new Date();
    params.push(timeFormat.toDate(start))
    params.push(timeFormat.toDate(end))
    return params
};
//去年
timeFormat.getLastYear = function (params = []) {
    let Nowdate = new Date();
    let LastYearFirstDay = (Nowdate.getFullYear() - 1) + "/01/01";
    let LastYearLastDay = (Nowdate.getFullYear() - 1) + "/12/31";
    const start = new Date(LastYearFirstDay);
    const end = new Date(LastYearLastDay);
    params.push(timeFormat.toDate(start))
    params.push(timeFormat.toDate(end))
    return params
};
//今年
timeFormat.getThisYear = function (params = []) {
    const end = new Date();
    let t = new Date().getFullYear() + '/01/01'
    const start = new Date(t)
    params.push(timeFormat.toDate(start))
    params.push(timeFormat.toDate(end))
    return params
};
//过去7天
timeFormat.getSevenDaysAgo = function (params = []) {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    params.push(timeFormat.toDate(start))
    params.push(timeFormat.toDate(end))
    return params
};
//过去30天
timeFormat.getThirtyDaysAgo = function (params = []) {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
    params.push(timeFormat.toDate(start))
    params.push(timeFormat.toDate(end))
    return params
};
//今日至将来29天
timeFormat.getThirtyDaysLater = function (params = []) {
    const end = new Date();
    const start = new Date();
    end.setTime(end.getTime() + 3600 * 1000 * 24 * 29);
    params.push(timeFormat.toDate(start))
    params.push(timeFormat.toDate(end))
    return params
};
export default timeFormat;
